import { render } from "./PushNotificationBlockedByBrowser.vue?vue&type=template&id=34712d71"
import script from "./PushNotificationBlockedByBrowser.vue?vue&type=script&lang=js"
export * from "./PushNotificationBlockedByBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__